module.exports = __webpack_public_path__ + "assets/media/office365.20f0a211.svg";